<template>
  <div id="app">
      <header class="header header_style1" 
      :class="{login: ['login','register','retriever'].includes($route.name)}"
        style="z-index: 22;"
        v-if="!['ServiceTerms','download'].includes($route.name)">
         <div class="container">
            <div class="row">
               <div class="col-md-9 col-lg-10">
                  <div class="logo">
                    <a href="index.html">
                      <img v-if="['login','register','retriever'].includes($route.name)" 
                        src="./assets/template/images/logo2.png" alt="">
                      <img v-else src="./assets/template/images/logo.png" alt="#" />
                    </a>
                  </div>
                  <div class="main_menu float-right">
                     <div class="menu"> 
                        <ul class="clearfix">
                           <li :class="{active: $route.name === 'home'}"><a href="/#/">主页</a></li>
                           <li :class="{active: $route.name === 'products'}"><a href="/#/products" >产品</a></li>
                           <li :class="{active: $route.name === 'instructions'}"><a href="/#/instructions">安装说明</a></li>
                           <!-- <li :class="{active: $route.name === 'download'}"><a href="/#/download">Download</a></li>
                           <li><a href="/ServiceTerms">Terms & Privacy Policy</a></li> -->
                        </ul>
                     </div>
                  </div>
               </div>
               <div class="col-md-3 col-lg-2" v-if="(!$store.state.userInfo || !$store.state.userInfo.email) && !['login','register','retriever'].includes($route.name)">
                  <div class="right_bt"><a class="bt_main" href="/#/login">登陆</a> </div>
               </div>
               <div class="col-md-3 col-lg-2" v-else>
                  <div class="right_bt userInfo">
                    <!-- <a class="bt_main" href="/login">Login</a>  -->
                      <div class="userInfo-i" :class="{showPopup: showPopup}" @click="showPopup = !showPopup">
                        <span class="email">
                          <span class="el-icon-s-custom" style="font-size: 12px;color: #797979"></span>
                          {{$store.state.userInfo.email}}</span>
                        <span class="el-icon-arrow-down"></span>
                        <div class="popup">
                            <div class="center" @click="toPersonal">
                              个人中心
                            </div>
                            <div class="password" @click="passwordDialog.switch = true;showPopup = false;">
                              修改密码
                            </div>
                            <div class="logout" @click="logout">
                              退出登录
                            </div>
                        </div>
                      </div>
                  </div>
               </div>
            </div>
         </div>
      </header>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <div >
      <router-view class="router_body" />
    </div>
    <footer class="footer_style_2" v-if="!['login','register','retriever'].includes($route.name)">
      <div class="footer_nav_o">
        <div class="footer_nav">
          <div class="footer_nav_row">
            <div class="footer_nav_row_box">
              <div class="_title">产品</div>
              <div class="_nav">
                <span class="link">
                  <a href="/#/home">主页</a>
                </span>
              </div>
              <div class="_nav">
                <span class="link">
                  <a href="/#/products">产品列表</a>
                </span>
              </div>
              <div class="_nav">
                <a href="/#/download">下载APP</a>
              </div>
            </div>
          </div>
          <div class="footer_nav_row">
            <div class="footer_nav_row_box">
              <div class="_title">服务</div>
              <div class="_nav">
                <a href="/ServiceTerms#UserAgreement">服务条款</a>
              </div>
              <div class="_nav">
                <a href="/ServiceTerms#PrivacyPolicy">隐私政策</a>
              </div>
            </div>
          </div>
          <div class="footer_nav_row">
            <div class="footer_nav_row_box">
              <div class="_title">联系我们</div>
              <div class="_nav">cicadasing@cicadasing.com</div>
              <div class="_nav qrcode">
                <div class="support">
                  <div class="title">蝉鸣技术支持</div>
                  <div class="qrcode_box">
                    <div class="qrcode">
                      <div class="img">
                        <img src="./assets/supports/1.png" alt="">
                      </div>
                      <div class="name">
                        <div class="avatar">
                          <img src="./assets/supports/avatar.png" alt="" />
                        </div>
                        <div class="str">蝉鸣技术客服</div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_bottom">
        <!-- <p>Dessigned and developed by <strong>html.design</strong></p> -->
        <p>© 2020 Cicadasing Technology LLC. All rights reserved.</p>
      </div>
    </footer>
    <!-- <el-dialog
      title="修改密码"
      :visible.sync="passwordDialog.switch">
          <el-form ref="form" class="form"
                :model="passwordDialog.form" :rules="rules" label-position="left"  label-width="35">
                  <el-form-item label=" " prop="password">
                    <el-input type="password" placeholder="请输入原密码" prefix-icon="el-icon-unlock" v-model="passwordDialog.form.password" />
                  </el-form-item>
                  <el-form-item label=" " prop="newPassword">
                    <el-input type="password" placeholder="请输入新密码" prefix-icon="el-icon-unlock" v-model="passwordDialog.form.newPassword" />
                  </el-form-item>
                  <el-form-item label=" " prop="confirmPassword">
                    <el-input type="password" placeholder="请确认新密码" prefix-icon="el-icon-unlock"  v-model="passwordDialog.form.confirmPassword" />
                  </el-form-item>
                  <el-form-item>
                    <div class="buttons">
                        <el-button @click="changePassword" type="success" style="width:100%;">
                          确认</el-button>
                        <el-button @click="passwordDialog.switch = false;" style="width:100%;">
                          取消</el-button>
                    </div>
                  </el-form-item>
            </el-form>
    </el-dialog> -->
    <div class="dialogForm" :class="{show: passwordDialog.switch}">
      <div class="dialogForm-i">
        <div class="dialogForm_header">
            <span class="str">修改密码</span>
            <span class="close el-icon-close" @click="passwordDialog.switch = false"></span>
        </div>
        <el-form ref="form" class="form"
              :model="passwordDialog.form" :rules="rules" label-position="left"  label-width="35">
              <el-form-item label=" " prop="oldPassword">
                <el-input type="password" placeholder="请输入原密码" prefix-icon="el-icon-unlock" v-model="passwordDialog.form.oldPassword" />
              </el-form-item>
              <el-form-item label=" " prop="newPassword">
                <el-input type="password" placeholder="请输入新密码" prefix-icon="el-icon-unlock" v-model="passwordDialog.form.newPassword" />
              </el-form-item>
              <el-form-item label=" " prop="confirmPassword">
                <el-input type="password" placeholder="请确认新密码" prefix-icon="el-icon-unlock"  v-model="passwordDialog.form.confirmPassword" />
              </el-form-item>
              <div class="buttons">
                  <el-button @click="changePassword" type="success" style="width:100%;">
                    确认</el-button>
                  <el-button @click="passwordDialog.switch = false;" style="width:100%;">
                    取消</el-button>
              </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
*{
  margin:0;padding:0;
  box-sizing: border-box;
  /* color:#333; */
  font-family: "helvetica";
}
#app {
  .dialogForm{
    .link{
        color: #3FB8A4;
      text-decoration: underline;
      cursor: pointer;
      &:hover{color:#359b8a}
    }
    position: fixed;
    width: 100vw;
    height:100vh;
    left:0;top:0;
    background:rgba(0,0,0,0.4);
    transform: translateY(100%);
    opacity: 0;
    z-index: 99;
    display:flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.5s;
    &.show{
      transform: translateY(0px);
      opacity: 1;
    }
    .dialogForm-i{
      max-width:450px;
      width:80%;
      background:#fff;
      .dialogForm_header{
        line-height:48px;
        justify-content: space-between;
        padding:0 15px;
        border-bottom:1px solid #ddd;
        display: flex;
        align-items: center;
        .str{
          font-size:18px;
          font-weight: bold;
        }
        .close{
          transition: all 0.5s;
          &:hover{
            transform: rotate(360deg);
          }
        }
      }
      .el-form{
        margin-top:15px;
        padding: 15px;
        .el-form-item{
            display: flex;
            .el-form-item__label{
              width:20px;
            }
            .el-form-item__content{
              flex-grow: 1;
            }
        }
        .buttons{
          display:flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .el-button{
            max-width: 200px;

            margin:8px 0;
          }
        }
      }
    }
  }
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  .router_body{
    min-height:calc(100vh - 150px);
    padding-bottom:95px;
  }
  .footer_style_2{
    padding-top:0;
    background: #3FB6AD;
    color:#fff;
  }
  .footer_nav_o{
  }
  .footer_nav{
    width:100vw;
    max-width:1200px;
    padding-top:1%;
    margin:auto;
    display:flex;
    justify-content: center;
    border-bottom: 0.5px solid #3bc7bd;
    padding-bottom: 15px;
    .footer_nav_row{
      flex-grow: 1;
      display:flex;
      flex-direction: column;
      align-items: center;
      .footer_nav_row_box{
        display:inline-block;
        ._title{
          font-weight: bold;
          font-size:18px;
          margin-bottom:5px;
        }
        ._nav{
          padding:8px 0;
          .link{
            cursor: pointer;
            &:hover{
              text-decoration: underline;
            }
          }
          a{
            color:#fff;
            text-decoration: none !important;
            &:hover{
              text-decoration: underline !important;
            }
          }
          .support{
            .qrcode_box{
              margin-top:5px;
              overflow:hidden;
              .qrcode{
                float:left;
                margin-right:5px;
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 0px rgba(0, 53, 44, 0.25);
                border-radius: 2px;
                padding:5px;
                .img{
                  img{
                    width:180px;
                  }
                }
                .name{
                  display:flex;
                  // justify-content: left;
                  align-items: center;
                  color:#333;
                  .avatar{
                    img{
                      width:36px;
                    }
                  }
                  .str{
                    padding-left:5px;
                    font-size:12px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 600px){
  .footer_nav{
    flex-direction: column;
    .footer_nav_row{
      
      align-items: flex-start !important;
      padding: 2% 15%;
    }
  }
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}
.userInfo{
  display:flex;
  justify-content: center;
  align-items: center;
  margin-top:21px !important;
  // margin:0 !important;
  // height:100%;
  .userInfo-i{
    padding: 0 15px;
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    position:relative;
    cursor:pointer;
    white-space: nowrap;
    // &:hover{
    //   .popup{
    //     opacity:1;
    //     transform: translateX(0px);
    //   }
    //   .el-icon-arrow-down{
    //     transform: rotate(180deg);
    //   }
    // }
    &.showPopup{
      .popup{
        opacity:1;
        transform: translateX(0px);
      }
      .el-icon-arrow-down{
        transform: rotate(180deg);
      }
    }
    .email{

    }
    .el-icon-arrow-down{
      font-size: 12px;
      margin-left:8px;
    }
    .popup{
      opacity:0;
      transform: translateX(299px);
      position:absolute;
      top: 100%;
      max-width: 120px;
      // height: 88px;
      background: #FFFFFF;
      box-shadow: 0px 3px 6px 0px rgba(0, 53, 44, 0.25);
      border-radius: 2px;padding: 0 13px;
      .center,.logout,.password{
        padding-left:25px;
        height:44px;
        line-height:44px;
        font-size:12px;
        background:#fff;
        cursor: pointer;
        &:hover{
          color: #3FB8A4;
        }
      }
      .center{
        background:url("./assets/img2/icon_center.png") no-repeat left center;
      }
      .logout{
        background:url("./assets/img2/icon_power.png") no-repeat left center;
      }
      .password{
        background:url("./assets/img2/icon_password.png") no-repeat left center;
      }
    }
  }
}
#nav a.router-link-exact-active {
  color: #42b983;
}
.button{
  &[disabled]{
    background:#ccc !important;
    cursor: wait;
  }
    border: none;
    outline: none;
    &.large{
      height:55px;
      line-height:55px;
      font-size:30px;
      font-weight: bold;
      background-image:url("./assets/image/download_icon_min.png");
      background-position: 17px 7px;
      background-repeat: no-repeat;
      padding: 0 20px 0 60px;
      border-radius: 39px;
      box-shadow: 10px 10px 20px rgba(0, 71, 61, 0.2);
    }
    &.login{
      height:42px;
      line-height:42px;
      font-size:14px;
      padding: 0 60px;
      box-shadow: 2px 1px 8px rgba(0, 71, 61, 0.2);
      background:#3FB5B1;
      color:#fff;
      border-radius: 4px;
    }
    display: inline-block;
    padding:0 15px;
    height: 26px;
    background-color: #FFFFFF;
    box-shadow: 0px 3px 6px rgba(0, 33, 14, 0.16);
    opacity: 1;
    border-radius: 21px;
    color:#3FB6AF;
    line-height:26px;
    cursor: pointer;
    transition: background 0.5s;
    font-size:12px;
    &:active{
      background-color:#efe0e0;
    }
    &.solid{
      padding:0 15px;
      height: 26px;
      border: 1px solid #FFFFFF;
      opacity: 1;
      border-radius: 21px;
      background:transparent;
      color:#fff;
      box-shadow: none;
      cursor: pointer;
    }
  }
  
        *{margin:0;padding:0;box-sizing: border-box;}
        #root span{
            background-color: #4aca85;
            display: inline-block;
            width: 20px;
            height: 20px;
            margin: 0 3px;
            border-radius: 50%;
            -webkit-transform: scale(0);
            -ms-transform: scale(0);
            transform: scale(0);
            -webkit-animation: 1s ball-load ease-in-out infinite;
            animation: ball-load 1s ease-in-out infinite;
        }
        @-webkit-keyframes ball-load {
            0% {
                -webkit-transform: scale(0)
            }

            50% {
                -webkit-transform: scale(1)
            }

            100% {
                -webkit-transform: scale(0)
            }
        }

        @keyframes ball-load {
            0% {
                transform: scale(0)
            }

            50% {
                transform: scale(1)
            }

            100% {
                transform: scale(0)
            }
        }
        
.el-button.el-button--primary{
    background: #3fb8a4 !important;
    border-color:#3fb8a4 !important;
    &:hover{
      opacity: 0.8;
    }
    &:active{
        background: #308c7d !important;
        border-color:#308c7d !important;
    }
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background-color: #3fb8a4 !important;
    border-color: #3fb8a4 !important; 
}
.el-checkbox__input.is-checked+.el-checkbox__label{
      color: #3fb8a4 !important;
}
.clearfix{
  z-index:199;
}
@media screen and (max-width: 767px){
  .menu-mobile:hover,.menu-mobile:focus,.menu-mobile:active{
    border-color: #339891 !important;
    color: #339891 !important;
  }
  .clearfix{
    transform: translateX(100vw);
    &.show-on-mobile{
      transform: translateX(0);
      color:#333 !important;
      a{
        color:#333 !important;
      }
    }
  }
  .userInfo{
    margin-top:0 !important;
    justify-content: flex-end !important;
    .userInfo-i{
      .popup{
        // display:none;
      }
    }
  }
}

</style>


<script>
import openCallback from "@/public/method/openCallback"
import logoutCallback from "@/public/method/logoutCallback";
import server from "@/public/service"
import {SUCCESS_CODE} from "@/public/state";
import encrypt from "@/public/method/encrypt";

export default {
  data(){
    return{
      showPopup: false,
      passwordDialog:{
        switch: false,
        form:{
          oldPassword:"",
          newPassword:"",
          confirmPassword:""
        },
      },
      rules:{
          oldPassword:[
              {
                required:true,message:"原密码不能为空",trigger: 'blur'
              },
          ],
          newPassword:[{
              required:true,message:"新密码不能为空",trigger: 'blur' 
          }],
          confirmPassword:[
            {required:true,message:"确认密码不能为空",trigger: 'blur'},
              { validator:(scope=>(rule, value, callback) => {
                  if (value !== scope.passwordDialog.form.newPassword) {
                    callback(new Error('两次密码不一致'));
                  } else{
                    callback()
                  }
              })(this), trigger: 'blur' },
          ]
      }
    }
  },
  methods:{
    toPersonal(){
      this.$router.push("/orderHistory")
    },
    logout(){
      logoutCallback.call(this)
    },
    changePassword(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
              server.changePassword({
                oldPassword: encrypt(this.passwordDialog.form.oldPassword),
                newPassword: encrypt(this.passwordDialog.form.newPassword),
                userId: this.$store.state.userInfo.id,
              }).then(data=>{
                if(data.reCode === SUCCESS_CODE){
                  this.$message({
                    type:"success",
                    message:"修改密码成功",
                    showClose: true
                  });
                  this.passwordDialog.switch = false;
                  this.passwordDialog.form.oldPassword = "";
                  this.passwordDialog.form.newPassword = "";
                  this.passwordDialog.form.confirmPassword = "";
                }
              })
          } else {
              return false;
          }
        });
    },
  },
  watch:{
    '$route'(){
      try{
        var html = document.getElementsByTagName("html")[0];
        var body = document.getElementsByTagName("body")[0];
        body.scrollTop = 0;
        html.scrollTop = 0;
      }catch(e){ 

      }
    }
  },
  created(){
    openCallback.call(this);
    console.log("app start  ")
    // console.log("this.$rouer.path",this.$route.path);
  }
}
</script>